import React, { useEffect, useState } from "react";
import {
  CBadge,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CRow,
} from "@coreui/react";
import "./QuizComponent.css";

function NumericResponse({
  type,
  num,
  question,
  score,
  onAnswerChange,
  questionID,
  questionTypeID,
  data,
  isCorrect,
  correctAnswer, // Add correctAnswer prop
  userAnswer, // Add userAnswer prop
  isReviewLoaded, // Add isReviewLoaded prop
  valueReset,
  isQuestionsFetched,
 currentPage,
}) {
  const [value, setValue] = useState("");
  const isDisabled = type === "review";

  useEffect(() => {
    // Reset value when questionID changes or valueReset is triggered
    setValue("");
  }, [questionID, valueReset]);

  const handleSelectAnswer = (newValue) => {
    setValue(newValue);
    onAnswerChange(questionID, questionTypeID, newValue);
  };

  const getClassName = () => {
    if (isCorrect === 1) {
      return "reviewAnswers";
    } else if (isCorrect === 0) {
      return "reviewAnswers2";
    } else {
      return "";
    }
  };

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <div>
                <span>
                  <span style={{fontWeight: '650'}}>{`Q${isQuestionsFetched ? currentPage : num + 1})`}</span>{' '}
                  <span style={{fontWeight: '650'}}>
                    {question}
                  </span>
                </span>
              <div className="flex">
                <CForm className="row g-2 align-items-center">
                  <CCol xs="auto"></CCol>
                  <CCol xs="auto">
                    <CFormInput
                      value={isReviewLoaded ? userAnswer : value}
                      className={getClassName()}
                      // Removed conditional disabling, always enabled
                      // disabled={type === "3" ? false : true}
                      disabled={isDisabled}
                      type="number"
                      id="exampleFormControlInput1"
                      onChange={(e) => handleSelectAnswer(e.target.value)}
                      aria-describedby="exampleFormControlInputHelpInline"
                    />
                  </CCol>
                  <div style={{padding:"5px"}}>
                    {isReviewLoaded && <p>Correct Answer: {correctAnswer}</p>} {/* Conditionally display correctAnswer */}
                  </div>
                </CForm>
              </div>
            </div>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge title="Score per question" shape="rounded-pill" color="primary">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default NumericResponse;
